import React from "react";
import cn from "classnames";
import { ThemeProvider, useTheme } from "styled-components";
import { useSelector } from "react-redux";

import {
    solfaParser,
    getColors,
    solfaNamesArray,
    isPitchPulsating,
    isMobile,
} from "../../../../../../common/parameters";
import { IStateTree } from "../../../../../store/interfaces";
import handsigns from "../../../../../icons/handsigns";
import { HandSignButton, Container, Scroll } from "./styles";
import { IProps } from "./interfaces";
import { IPitch } from "../../../../../../common/types";
import { IColorPalette, IUser } from "../../../../../store/user/models";

const HandSignLadder = ({
    hint,
    handleInput,
    withColors,
    solfaNameTypes,
    currentNote,
    alteration,
    alternatedPitches,
}: IProps) => {
    const { colors = 1 } = useSelector((state: IStateTree) => state.user as IUser);
    const theme = useTheme();
    const min = solfaNameTypes[0].i;
    const max = solfaNameTypes[solfaNameTypes.length - 1].i;
    return (
        <ThemeProvider theme={{ ...theme, c: { ...theme.c, solfa: getColors(colors as IColorPalette | number) } }}>
            <Scroll>
                <Container>
                    {Array.from({ length: 7 * 3 + 1 }).map((_, n) => {
                        if (n < min || n > max) return null;
                        let a: 1 | 0 | -1 = 0;
                        const octave = (Math.floor(n / 7) - 1) as IPitch["o"];
                        const solfa = solfaParser[n % 7];
                        if (alteration !== 0) {
                            if (
                                alternatedPitches.find(
                                    ap => ap.s === solfa && ap.a === alteration && (ap.o || 0) === octave
                                )
                            ) {
                                a = alteration;
                            }
                        }
                        const Icon = handsigns[solfa][a]!;
                        const halfStep = n % 7 === 2 || n % 7 === 6;
                        const isVisible = solfaNameTypes.findIndex(snt => snt.i === n) !== -1;
                        const action = {
                            [isMobile ? "onTouchStart" : "onClick"]: (e: TouchEvent | MouseEvent) => handleInput(solfa, octave, e),
                        };
                        return (
                            <HandSignButton
                                key={n}
                                className={cn({
                                    HalfStep: halfStep,
                                    Invisible: !isVisible,
                                    Disabled: alteration !== 0 && a === 0,
                                    pulsate: currentNote && hint && isPitchPulsating({ i: n }, currentNote.p as IPitch),
                                    Sharpened: a === 1,
                                    Flatened: a === -1,
                                })}
                                solfaShort={solfaNamesArray("hu")[n % 7].slice(0, 1)}
                                coloring={withColors}
                                {...action}
                            >
                                <Icon />
                            </HandSignButton>
                        );
                    })}
                </Container>
            </Scroll>
        </ThemeProvider>
    );
};

export default HandSignLadder;
